<mat-form-field class="mat-form-style mat-textarea" appearance="outline">
    <mat-label>{{placeholder}}</mat-label>
    <textarea matInput
              [(ngModel)]="inputText"
              (ngModelChange)="emitInputValue()"
              [required]="required"></textarea>
</mat-form-field>
